<div [ngClass]="headerPaddingClass" class="header-padding"></div>
<nav [ngClass]="headerClass" class="navbar navbar-expand-lg">
    <div class="container-fluid px-0">
        <!-- Vertical Menu Toggle -->
        <div (click)="globalService.toggleSideMenu()" *ngIf="sideMenuButton" class="d-inline-block d-lg-none side-menu-button">
            <i class="fas fa-user text-light"></i>
        </div>

        <a [routerLink]="['/']" class="navbar-brand"> <img class="logo-image" src="{{ this.logoUrl }}" /></a>

        <div
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            class="side-menu-button d-block d-md-none"
            data-bs-target="#navbarSupportedContent"
            data-bs-toggle="collapse"
        >
            <span class="fa fa-bars text-light"></span>
        </div>

        <div *ngIf="user" class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav">
                <li *ngIf="authService.isAdmin" class="nav-item">
                    <a [routerLink]="['/admin']" aria-current="page" class="nav-link text-primary" routerLinkActive="active">Admin</a>
                </li>
                <li *ngIf="!authService.isAdmin && authService.isEnterpriseManager" class="nav-item">
                    <a [routerLink]="['/admin']" aria-current="page" class="nav-link text-primary" routerLinkActive="active">Dashboard</a>
                </li>
                <li *ngIf="authService.isSalesManager && !authService.isAdmin && !authService.isEnterpriseManager" class="nav-item">
                    <a [routerLink]="['/admin/parker-crm/table']" aria-current="page" class="nav-link text-primary" routerLinkActive="active">CRM</a>
                </li>
            </ul>
            <ul class="navbar-nav ms-auto">
                <li class="nav-item">
                    <a [routerLink]="['/map-search']" aria-current="page" class="nav-link" routerLinkActive="active"> Find Parking </a>
                </li>

                <li class="nav-item">
                    <a [routerLink]="['/parkupp-for-business']" aria-current="page" class="nav-link" routerLinkActive="active"> ParkUpp for Business </a>
                </li>

                <li class="nav-item">
                    <a [routerLink]="['/landlord']" aria-current="page" class="nav-link" routerLinkActive="active"> List Your Parking </a>
                </li>

                <li class="nav-item">
                    <a [routerLink]="['/about-us']" aria-current="page" class="nav-link" routerLinkActive="active">About Us</a>
                </li>

                <li class="nav-item">
                    <a [routerLink]="['/faqs']" aria-current="page" class="nav-link" routerLinkActive="active">FAQs</a>
                </li>

                <li class="nav-item">
                    <a [routerLink]="['/contact']" aria-current="page" class="nav-link" routerLinkActive="active">Contact Us</a>
                </li>

                <li *ngIf="user.isAnonymous" class="nav-item dropdown">
                    <a aria-expanded="false" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button"> Login / Register </a>
                    <ul aria-labelledby="navbarDropdown" class="dropdown-menu">
                        <li>
                            <a (click)="onSignIn()" aria-current="page" class="nav-link" routerLinkActive="active"> Login </a>
                        </li>
                        <li>
                            <a (click)="onSignUp()" aria-current="page" class="nav-link" routerLinkActive="active"> Register </a>
                        </li>
                    </ul>
                </li>

                <li *ngIf="!user.isAnonymous" class="nav-item dropdown">
                    <a aria-expanded="false" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" id="navbarDropdownProfile" role="button">
                        <i *ngIf="!clientService.activeClient || !clientService.activeClient.profileImage || !clientService.activeClient.profileImage.smallUrl" class="fa fa-user-circle"></i>
                        <img
                            *ngIf="clientService.activeClient && clientService.activeClient.profileImage && clientService.activeClient.profileImage.smallUrl"
                            [src]="clientService.activeClient.profileImage.smallUrl"
                            class="header-profile-image"
                        />
                        <ng-container *ngIf="clientService.activeClient && clientService.activeClient.firstName">{{ clientService.activeClient.firstName }}</ng-container>
                        <ng-container *ngIf="!clientService.activeClient || !clientService.activeClient.firstName"> Account</ng-container>
                    </a>
                    <ul aria-labelledby="navbarDropdownProfile" class="dropdown-menu dropdown-menu-end">
                        <li><a [routerLink]="['/client', authService.uid]" class="dropdown-item" href="">Parker Profile</a></li>

                        <li>
                            <a (click)="onMerchantPortal()" class="dropdown-item" routerLinkActive="active"> Landlord Portfolios </a>
                        </li>
                        <li>
                            <hr class="dropdown-divider" />
                        </li>
                        <li><a (click)="signOut()" class="dropdown-item" href="">Logout</a></li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</nav>
